import Icon from '../components/Icon.vue'

Icon.register({"backward":{"width":512,"height":512,"paths":[{"d":"M11.5 280.6L203.5 440.6C224.1 457.8 256 443.4 256 416V96C256 68.6 224.1 54.2 203.5 71.4L11.5 231.4C-3.8 244.2-3.8 267.8 11.5 280.6zM267.5 280.6L459.5 440.6C480.1 457.8 512 443.4 512 416V96C512 68.6 480.1 54.2 459.5 71.4L267.5 231.4C252.2 244.2 252.2 267.8 267.5 280.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/backward.js
// module id = null
// module chunks = 